'use client';

import { useRef, useState } from 'react';
import type { RendererProps } from '../types';
import { PopupHeader, padded } from '../chrome';

/**
 * Plain HTML5 audio player. Completes on 90% playback.
 */
export function AudioRenderer({ item, onComplete }: RendererProps) {
  const body = (item.body as { audioUrl?: string; url?: string }) ?? {};
  const ref = useRef<HTMLAudioElement | null>(null);
  const [done, setDone] = useState(false);

  return (
    <>
      <PopupHeader kind={item.kind} title={item.title} description={item.description} />
      <div style={padded}>
        <audio
          ref={ref}
          src={body.audioUrl ?? body.url}
          controls
          onTimeUpdate={() => {
            const a = ref.current;
            if (!a || done) return;
            if (a.duration && a.currentTime / a.duration >= 0.9) {
              setDone(true);
              onComplete();
            }
          }}
          style={{ width: '100%' }}
        />
      </div>
    </>
  );
}
